import { CommonRouter } from '@primeit/components-vue';
import { getDebugger } from '@/utils';
const debug = getDebugger('pages/router-adjusts.js');

const originalPush = CommonRouter.push;

/**
 * @param {import('vue-router').RawLocation} location
 * @param {Function} [onComplete]
 * @param {Function} [onAbort]
 */
function pushOverride(location, onComplete, onAbort) {
  // Adicione sua lógica de override aqui.
  // Por exemplo, você pode inspecionar o `location`
  // e decidir se a navegação deve continuar.
  // console.log('Navegando para:', location);

  const result = originalPush.call(this, location, onComplete, onAbort);

  // O `push` do vue-router retorna uma promessa.
  // O catch existente previne que erros de navegação
  // (ex: NavigationDuplicated) apareçam no console como não tratados.
  if (result && typeof result.catch === 'function') {
    return result.catch((err) => {
      // Você pode tratar erros de navegação aqui.
      if (err.name !== 'NavigationDuplicated') {
        debug('Erro de navegação:', err);
      }
    });
  }

  return result;
}

CommonRouter.push = pushOverride.bind(CommonRouter);

CommonRouter.beforeResolve((to, from, next) => {
  try {
    const message = { event: 'sso_navigate', source: 'SSO', to: to.path };
    window.parent.postMessage(message, '*');
  } catch (error) {
    console.error(error);
  }

  next();
});
